export default __webpack_public_path__ + "static/media/bihada-factory-mission-04.a846b9cb.jpg";